import { render, staticRenderFns } from "./UiCheckBox.vue?vue&type=template&id=0457992f&scoped=true&"
import script from "./UiCheckBox.vue?vue&type=script&lang=js&"
export * from "./UiCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./UiCheckBox.vue?vue&type=style&index=0&id=0457992f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0457992f",
  null
  
)

export default component.exports